<template class="hour-balance">
    <template v-for="value in timeTypes" :key="'timeType' + value.id">
        <PlanbordGridCell
            v-if="mappedBalances && mappedBalances[value.id]"
            :title="'Op ' + formatDate(mappedBalances[value.id].date)"
            v-show="isTimeTypeEnabled(value.id)"
            balance
            info
        >
            <span :class="getClass(mappedBalances[value.id].value)">{{ mappedBalances[value.id].value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</span>
        </PlanbordGridCell>
        <PlanbordGridCell
            v-else
            v-show="isTimeTypeEnabled(value.id)"
            balance
            info
        >-</PlanbordGridCell>
    </template>
    <template v-for="value in leaveOverviews" :key="'overview' + value.id!">
        <PlanbordGridCell
            v-if="mappedLeaveOverviewBalance && mappedLeaveOverviewBalance[value.id!]"
            :title="'Op ' + formatDate(mappedLeaveOverviewBalance[value.id!].date)"
            v-show="isOverviewEnabled(value.id!)"
            balance
            info
        >
            <span :class="getClass(mappedLeaveOverviewBalance[value.id!].value)">{{ mappedLeaveOverviewBalance[value.id!].value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</span>
        </PlanbordGridCell>
        <PlanbordGridCell
            v-else
            v-show="isOverviewEnabled(value.id!)"
            balance
            info
        >-</PlanbordGridCell>
    </template>
    <template v-for="count in deploymentCounts" :key="'count' + count.configurationId">
        <PlanbordGridCell v-show="isCountEnabled(count.configurationId)" balance info>
            <span class="positive">
                {{ count.value }}
            </span>
        </PlanbordGridCell>
    </template>
</template>

<script lang="ts">
    import PlanbordGridCell from '@/components/Planbord/PlanbordGridCell.vue';
    import {BalanceUtil} from '@/util/BalanceUtil';
    import {BalanceFilterType} from '@/components/FilterBar/types';
    import {ResourceHourBalance, TimeType, LeaveOverview} from '@cquential/api';
    import Dates from '@cquential/date-utils';
    import {ResourceWithKeyedByDateObjects} from '@/types/api-object-extensions';
    import {DeploymentCountsOfResourceOrCompany} from '@/components/types';
    import {Component, Vue, Prop} from 'vue-facing-decorator';

    @Component({
        components: {
            PlanbordGridCell,
        },
    })
    export default class Balances extends Vue {
        @Prop({required: true}) public resource!: ResourceWithKeyedByDateObjects;
        @Prop({required: true}) public timeTypes!: Record<number, TimeType>;
        @Prop({required: true}) public enabledBalanceAndCountDisplays!: Record<BalanceFilterType, Record<number, boolean>>;
        @Prop({required: true}) public leaveOverviews!: LeaveOverview[];
        @Prop({required: true}) public deploymentCounts!: DeploymentCountsOfResourceOrCompany[];

        public get mappedBalances(): Record<number, ResourceHourBalance> | undefined {
            if (!this.resource.balances) {
                return undefined;
            }

            return BalanceUtil.getBalancesFromResource(this.resource);
        }

        public get mappedLeaveOverviewBalance(): Record<number, ResourceHourBalance> | undefined {
            if (!this.resource.balances) {
                return undefined;
            }

            return BalanceUtil.getLeaveOverViewBalancesFromResource(this.resource);
        }

        public formatDate(date: Date): string {
            return Dates.Formatter.formatDate(date);
        }

        public getClass(num: number): string {
            return num < 0 ? 'negative' : 'positive';
        }

        public isTimeTypeEnabled(id: number): boolean {
            return this.enabledBalanceAndCountDisplays[BalanceFilterType.HourBalance][id] ?? false;
        }

        public isOverviewEnabled(id: number): boolean {
            return this.enabledBalanceAndCountDisplays[BalanceFilterType.LeaveOverview][id] ?? false;
        }

        public isCountEnabled(id: number): boolean {
            return this.enabledBalanceAndCountDisplays[BalanceFilterType.DeploymentCount][id] ?? false;
        }
    }
</script>

<style lang="scss" scoped>
    span {
        &.positive {
            color: var(--theme-text-color);
        }

        &.negative {
            color: var(--negative-value-color);
        }
    }
</style>
